import React from "react";

// Lazy loading components for improved performance
// React.lazy is used to dynamically import components when they are needed
export const BookManagement = React.lazy(() => import("./BookList/index.page"));
export const BookDetails = React.lazy(() => import("./BookDetails/index.page"));
